import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row } from 'reactstrap';
import axios from 'axios'

// Import API config object
import { tokenConfig } from '../../utils/apiConfig'

const UpdateRegistration = (props) => {
    const { registration } = props
    const [email, setEmail] = useState('')
    const [status, setStatus] = useState('')

    useEffect(() => {
        if (registration._id) {
            setEmail(registration.email)
            setStatus(registration.status)
        }
    }, [registration])

    const updateRegistration = async e => {
        e.preventDefault()
        const updatedRegistration = {
            _id: registration._id, email, status
        }
        await axios.patch('/api/registrations', updatedRegistration, tokenConfig())
            .then(res => {
                setEmail('')
                setStatus('')
                props.toggle(false)
                // Update Registration List
                props.insertUpdatedRegistration()
            })
            .catch(err => console.log(err.message))
    }

    return (
        <Modal isOpen={props.updateRegistration} size='lg' toggle={() => props.toggle(false)}>
            <ModalHeader toggle={() => props.toggle(false)}>Modal title</ModalHeader>
            <Form onSubmit={updateRegistration}>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Registration Email</Label>
                                <Input type="text" defaultValue={email} onChange={e => setEmail(e.target.value)} required />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Status</Label>
                                <Input type="select" defaultValue={status} onChange={e => setStatus(e.target.value)} required>
                                    <option>Registered</option>
                                    <option>Checked In</option>
                                    <option>Cancelled</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button type='submit' color="primary">Update</Button>{' '}
                    <Button color="secondary" onClick={() => props.toggle(false)}>Cancel</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
}

export default UpdateRegistration;